export default __webpack_public_path__ + "static/media/STElevationMyocardialInfarction(STEMI)CarePathwaySTEMIflowchart.d4887a7e.jpg";